<template>
    <div class="topicIndex spackage padding-20 bgc box-shadow" v-loading="loading">
        <!-- start 顶部菜单栏 -->
        <section class="startMgt-header">
            <el-button type="primary" align="left" @click="addNewNotice()">新建公告</el-button>
            <div align="right" style="float:right;display: flex">
                <el-date-picker class="item" v-model="time.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
                <el-input placeholder="输入公告名称" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </section>
        <!-- end 顶部菜单栏 -->
        <section>
            <el-table :data="noticeData">
                <el-table-column prop="customername" label="用户名称" align="center" width="200px">
                    <template slot-scope="scope">
                        <div class="customerBox">
                            <img :src="scope.row.customerlogo" :alt="scope.row.articlename">
                            <span class="recommon">{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="content" label="内容" align="center" width="500"></el-table-column>
                <el-table-column prop="viewcount" label="浏览量" align="center"  width="100"></el-table-column>
                <el-table-column prop="commentcount" label="评论数" align="center"  width="100"></el-table-column>
                <el-table-column prop="praisecount" label="点赞数" align="center"  width="100"></el-table-column>
                <el-table-column prop="datetime" label="发布时间" align="center"></el-table-column>
                <el-table-column label="操作" align="right" width="100px">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <span @click="delClick(scope.row.innerid)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </section>
        <!-- start 弹窗 -->
        <el-dialog title="新增公告" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="公告内容" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="4" v-model="noticeName" autocomplete="off" placeholder="输入公告内容" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- end 弹窗 -->
    </div>
</template>

<script>
    import {getNoticeList,saveNotice,delNotice} from '@/api/communityApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters,mapActions} from 'vuex'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    export default {
        name: "noticeMgt",
        data(){
            return{
                loading: false, // 加载
                dialogFormVisible: false,
                formLabelWidth: '80px',
                noticeName:'', //新建公告
                total: 0,   //表格页数
                noticeData:[],   //表格数据
                searchName:'', //搜索话题
                time: {             // 开始/结束时间
                    date: ''
                },
                form:{

                }
            }
        },
        components: {
            Loading,
            Page
        },
        mounted() {
            this.setLoading(true);
            this.apiData = {
                starid:this.$route.query.innerid,
                page: 1,
                pageSize: 10
            };
            this.noticeMgtEvent()
        },
        methods: {
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            ...mapActions([
                'setLoading'
            ]),
            // 新建公告
            addNewNotice() {
                this.noticeName = '';
                this.dialogFormVisible = true
            },
            // 确定添加公告
            sureAdd() {
                this.setLoading(true);
                let params = {
                    starid:this.$route.query.innerid,
                    content: this.noticeName
                };
                saveNotice({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message({type: 'success', message: '添加成功！'});
                        this.noticeMgtEvent()
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message.error(data.msg)
                    }
                })
            },
            // 删除公告
            delClick(id) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        innerid: id,
                        starid:this.$route.query.innerid,
                    };
                    this.setLoading(true);
                    delNotice({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.noticeMgtEvent();
                            this.$message.success(`删除成功!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            //公告列表
            noticeMgtEvent() {
                getNoticeList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.noticeData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let searchDate = this.time;
                let params = {
                    starid:this.$route.query.innerid,
                    keyword: this.searchName,
                    beginTime:searchDate.date[0]?fecha.format(searchDate.date[0], 'yyyy-MM-dd'):'',
                    endTime:searchDate.date[1]?fecha.format(searchDate.date[1], 'yyyy-MM-dd'):'',
                };
                getNoticeList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.noticeData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
        },
        computed: {
            ...mapGetters([
                'page',
                'user'
            ])
        },
    }
</script>
<style scoped lang="scss">
    .topicIndex {
        display: flex;
        flex-direction: column;
        .textStyle{
            height: 96px;
            .el-textarea__inner{
                height: 100%!important;
            }
        }
    }
    .startMgt-header {
        width: 100%;
        height: 40px;
        margin-bottom: 12px;
        .el-button {
            height: 32px;
        }
        .el-input {
            margin-right: 20px;
        }
    }
    .table-position{
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span{
            color: #409EFF;
            cursor: pointer;
        }
    }
    .customerBox{
        display: flex;
        align-items: center;
        img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    /*样式更改 日期选择*/
    .el-range-editor.el-input__inner{
        padding: 0 10px;
    }
    .topicIndex .el-date-editor {
        margin-right: 20px;
    }
</style>
